import type { ContactSummaryDto } from '@fluenceur/types';
import type { TFunction } from 'i18next';
import { formatLongDate } from '@/lib/format-long-date';

/**
 * What holds back the brand's automatic flow messages to this person, in one line, or '' when
 * nothing does. Her own request to stop comes first: it outweighs a pause on proposals.
 */
export function contactAutomaticMessagesNote(
  automatic: ContactSummaryDto['automaticMessages'],
  t: TFunction,
  locale: string
): string {
  if (automatic?.optedOut) return t('contactDrawer.rail.contact.automaticMessagesStopped');
  if (automatic?.proposalsPausedUntil)
    return t('contactDrawer.rail.contact.proposalsPausedUntil', {
      date: formatLongDate(automatic.proposalsPausedUntil, locale),
    });
  return '';
}
